import { useState } from "react"
import {
  Image,
  Dialog,
  Portal,
  Box,
} from "@chakra-ui/react"

export function ImageWithModal({
  src,
  alt = "",
  thumbProps,
}) {
  const [open, setOpen] = useState(false)

  return (
    <>
      {/* Thumbnail / inline image */}
      <Image
        src={src}
        alt={alt}
        cursor="zoom-in"
        onClick={() => setOpen(true)}
        {...thumbProps}
      />

      {/* Modal */}
      <Dialog.Root open={open} onOpenChange={(e) => setOpen(e.open)} >
        {/* placement="center" size={{ mdDown: "full", md: "lg" }} */}
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content
              p={0}
              bg="transparent"
              boxShadow="none"
              w="auto"
              h="auto"
              maxW="calc(100vw - 32px)"
              maxH="calc(100vh - 32px)"

            >
              {/* <Box
       
                display="flex"
                alignItems="center"
                justifyContent="center"
              > */}


              <Dialog.Body>
                <Image
                  src={src}
                  alt={alt}
                  maxW="100%"
                  // maxH="100%" .
                  maxH="calc(100vh - 96px)"
                  w="auto"
                  h="auto"
                  objectFit="contain"
                  borderRadius="lg"
                  cursor="zoom-out"
                  onClick={() => setOpen(false)}
                />
              </Dialog.Body>
              {/* </Box> */}
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </>
  )
}